
/* injects from baggage-loader */

'use strict';

export default class TermsOfUseController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/legal/terms-of-use/terms-of-use.controller.js